const ArrowIcon = ( { className } ) => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
				 className={className}>
			<path
				d="M19.0003 16.0003C18.7443 16.0003 18.4882 15.9023 18.2933 15.7073L12.0003 9.41434L5.70731 15.7073C5.31631 16.0983 4.68425 16.0983 4.29325 15.7073C3.90225 15.3163 3.90225 14.6842 4.29325 14.2933L11.2933 7.29325C11.6842 6.90225 12.3163 6.90225 12.7073 7.29325L19.7073 14.2933C20.0983 14.6842 20.0983 15.3163 19.7073 15.7073C19.5123 15.9023 19.2563 16.0003 19.0003 16.0003Z"
				fill="#663497"/>
		</svg>
	);
};

export default ArrowIcon;
